<script setup lang="ts">
import { useDefaultStore } from '@/stores/defaultStore'
import { useRoute } from 'vue-router'

const defaultStore = useDefaultStore()
const route = useRoute()

defineProps<{
  title?: string
  subtitle?: string
}>()
</script>

<template>
  <div class="flex items-center gap-4 px-6 pb-5 pt-6 -m-6 mb-10 bg-slate-100 shadow sticky top-0 z-10">
    <div>
      <slot name="title">
        <div class="text-2xl font-bold">{{ title || defaultStore.pageTitle || route.name }}</div>
      </slot>
      <slot name="breadcrumb"></slot>
    </div>
    <div class="text-neutral-500 self-end pb-0.5">
      <slot name="subtitle">
        {{ subtitle }}
      </slot>
    </div>
    <div class="ml-auto flex items-center gap-2">
      <slot name="extra"></slot>
    </div>
  </div>
</template>
